import 'date-fns';
import React from "react";
import {
  Typography, Accordion, AccordionSummary,
  AccordionDetails, makeStyles, createStyles,
  Theme, Chip, Grid,
  IconButton, CircularProgress
} from '@material-ui/core';
import AttachFileOutlinedIcon from '@material-ui/icons/AttachFile';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EmailIcon from '@material-ui/icons/Email';
import EditIcon from '@material-ui/icons/Edit';
import { green } from '@material-ui/core/colors';
import { typeUserInfo } from '../../../../api/helpline/user'
import { typeQaContent, typeUserInfoList } from '../../../../api/helpline/qa'
import { typeMemberList } from '../../../../api/helpline/master';
import { format, isValid, parseISO } from "date-fns";

const keiyakuss = process.env.REACT_APP_KEIYAKU_APP_SS!
const keiyakuss400 = process.env.REACT_APP_KEIYAKU_APP_SS400!

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '20%',
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
      flexGrow: 1
    },
    chip: {
      color: theme.palette.text.secondary,
      flexShrink: 0,
      margin: 'auto',
    },
    label: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightBold,
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    accordion: {
      wordBreak: 'break-all',
    },
    iconButton: {
      padding: '0px 3px',
      marginRight: theme.spacing(1),
      opacity: 0.8,
    },
    dialogtitle: {
      display: 'flex',
      alignItems: 'center',
    }
  }),
);

interface Props {
  qaContent: typeQaContent | undefined,
  dateFormat: (datevalue: Date | string) => string,
  userInfo: typeUserInfo | undefined,
  qaEnvironment: { [name: string]: string },
  fileloading: boolean,
  mailDialog: boolean,
  member: typeMemberList | undefined,
  handleOpenMail: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  userInfoList: typeUserInfoList | undefined,
  fileDownload: (filepath: string) => void,
  handleOpenBasicEdit: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  displayIncident: boolean,
  incidentValidCount: number,
  incidentRemain: number
}

const QAContent: React.FC<Props> = (props) => {
  const { fileloading, userInfoList, qaContent, member, handleOpenMail, dateFormat, userInfo, qaEnvironment, fileDownload, handleOpenBasicEdit, displayIncident, incidentRemain, incidentValidCount } = props
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const newLine = (str: string) => {
    return str.split(/\r\n|\n/).map((value, index) => {
      if (value) {
        return <Typography>{value}</Typography>
      } else {
        return <br />
      }
    })
  }

  // 問合せ日フォーマット
  const qaStartStFormat = (datevalue: Date | string): string => {
    let date = datevalue
    if (typeof date === 'string') {
      date = parseISO(date)
    }
    if (isValid(date)) {
      return format(date, 'yyyy/MM/dd HH:mm:ss')
    } else {
      return '　'
    }
  }

  return (
    <React.Fragment>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} className={classes.accordion}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>問合せ</Typography>
          <Typography className={classes.secondaryHeading}>{qaContent && qaContent.qaTitle}</Typography>
          <IconButton color="secondary" className={classes.iconButton} onClick={handleOpenBasicEdit}>
            <EditIcon />
          </IconButton>
          {qaContent?.qaStatusClsCd !== '4' && qaContent?.qaStatusClsCd !== 'd' &&
            <IconButton color="primary" className={classes.iconButton} onClick={handleOpenMail}>
              <EmailIcon />
            </IconButton>}
          <Chip className={classes.chip} size="small" label={qaContent && qaContent.qaStatusClsName} />
        </AccordionSummary>
        <AccordionDetails>
          <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
            <Grid item xs={12} md={3}>
              <Typography className={classes.label}>質問番号</Typography>
              <Typography>{qaContent && qaContent.qaNo}</Typography>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography className={classes.label}>問合せ日時</Typography>
              <Typography>{qaContent && qaContent.qaStartSt ? qaStartStFormat(qaContent.qaStartSt) : '　'}</Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography className={classes.label}>顧客名 / 組織名</Typography>
              <Typography>{userInfoList && userInfoList.customerName} / {userInfo && userInfo.departmentName}</Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography className={classes.label}>契約項目</Typography>
              <Typography>{qaContent && qaContent.keiyakuClsName}</Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography className={classes.label}>質問者名</Typography>
              <Typography>{qaContent && qaContent.qPersonName + '/'}{member && member.telephoneNumber + '/'}{member && member.emailAddress1}</Typography>
            </Grid>

            {displayIncident &&
              <React.Fragment>
                <Grid item xs={12} md={6}>
                  <Typography className={classes.label}>有効インシデント</Typography>
                  <Typography>{incidentValidCount}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography className={classes.label}>残インシデント</Typography>
                  <Typography>{incidentRemain}</Typography>
                </Grid>
              </React.Fragment>
            }

            {(qaContent?.keiyakuClsCd === keiyakuss400 || qaContent?.keiyakuClsCd === keiyakuss) &&
              <React.Fragment>

                <Grid item xs={12} md={4}>
                  <Typography className={classes.label}>SSバージョン</Typography>
                  <Typography>{qaEnvironment.ss_version ? qaEnvironment.ss_version : '　'}</Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Typography className={classes.label}>サーバー環境(OS)</Typography>
                  <Typography>{qaEnvironment.ss_serverOS ? qaEnvironment.ss_serverOS : '　'}</Typography>
                </Grid>
                {qaContent?.keiyakuClsCd === keiyakuss400 &&
                  <Grid item xs={12} md={4}>
                    <Typography className={classes.label}>サーバー環境(接続)</Typography>
                    <Typography>{qaEnvironment.ss_serverConnect ? qaEnvironment.ss_serverConnect : '　'}</Typography>
                  </Grid>
                }
                {qaContent?.keiyakuClsCd === keiyakuss &&
                  <React.Fragment>
                    <Grid item xs={12} md={4}>
                      <Typography className={classes.label}>サーバー環境(DB)</Typography>
                      <Typography>{qaEnvironment.ss_serverDB ? qaEnvironment.ss_serverDB : '　'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography className={classes.label}>アプリケーションサーバー</Typography>
                      <Typography>{qaEnvironment.ss_applicationserver ? qaEnvironment.ss_applicationserver : '　'}</Typography>
                    </Grid>
                  </React.Fragment>
                }
                <Grid item xs={12} md={4}>
                  <Typography className={classes.label}>クライアント環境(OS)</Typography>
                  <Typography>{qaEnvironment.ss_clientOS ? qaEnvironment.ss_clientOS : '　'}</Typography>
                </Grid>
                {qaContent?.keiyakuClsCd === keiyakuss &&
                  <Grid item xs={12} md={4}>
                    <Typography className={classes.label}>クライアント環境(DB)</Typography>
                    <Typography>{qaEnvironment.ss_clientDB ? qaEnvironment.ss_clientDB : '　'}</Typography>
                  </Grid>
                }
              </React.Fragment>
            }

            <Grid item xs={12} md={6} lg={3}>
              <Typography className={classes.label}>問合せ方法</Typography>
              <Typography>{qaContent ? qaContent.qaWayClsName : '　'}</Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <Typography className={classes.label}>回答希望日</Typography>
              <Typography>{qaContent && (qaContent.answerDate ? dateFormat(qaContent.answerDate) : '　')}</Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <Typography className={classes.label}>関連Q&A番号</Typography>
              <Typography>{qaContent && qaContent.relatedQaNo ? qaContent.relatedQaNo : '　'}</Typography>
            </Grid>

            {qaContent?.qaStatusClsCd === '4' &&
              <Grid item xs={12} md={6} lg={3}>
                <Typography className={classes.label}>対応時間</Typography>
                <Typography>{qaContent?.qaTotalTime} 時間</Typography>
              </Grid>
            }
            <Grid item xs={12}>

              <Typography className={classes.label}>問合せタイトル</Typography>
              <Typography>{qaContent && qaContent.qaTitle ? qaContent.qaTitle : '　'}</Typography>
            </Grid>
            <Grid item xs={12}>

              <Typography className={classes.label}>問合せ内容</Typography>
              {qaContent && qaContent.qaContents ? (newLine(qaContent.qaContents)) : (<Typography>　</Typography>)}
            </Grid>
            <Grid item xs={12}>

              <Typography className={classes.label}>添付ファイル</Typography>
              {qaContent && qaContent.attachedFile ? (
                <IconButton component="span" size="small" disabled={fileloading} onClick={(event: any) => fileDownload(qaContent.attachedFile!)}>
                  <AttachFileOutlinedIcon />
                  {fileloading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </IconButton>
              ) : (<Typography>　</Typography>)}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </React.Fragment >
  )
}

export default QAContent